import angular from 'angular';
import akamSwitch from './switch-component';

export default angular
  /**
   * @ngdoc module
   * @name akamai.components.switch
   *
   * @guideline https://design.akamai.com/components/switch/
   *
   * @description
   * A switch is similar to a radio button. It lets users choose between two values.
   * Traditionally, these values are binary operations, such as "On" and "Off"
   * or "Allow" and "Deny".
   * The switch affordance lets users think of a real-world switch that can
   * toggle between two states.
   *
   * @example switch.html
   * <akam-switch ng-model="..."></akam-switch>
   */
  .module('akamai.components.switch', [

  ])

  /**
   * @ngdoc directive
   * @name akamSwitch
   * @module akamai.components.switch
   *
   * @description Creates a switch component.
   *
   * @param {boolean} [isDisabled=false] If disabled, no user interaction
   * will be possible.
   * @param {boolean} [isReadonly=false] If readonly, no user interaction
   * will be possible but the text will be easier to read.
   * @param {boolean} ngModel The switch's state.
   */
  .component('akamSwitch', akamSwitch);
